import React from 'react';
import { StaffNames } from '../shared/NowName';

// 案子現任的 Partner／Director／Manager／Team——開 CaseWare、charge code 都要
// 知道開給誰，所以 CWCC 不論申請哪一項都列。名單取案子現況（live），不是申請單快照。
const ROLES = [
  ['Partner', 'partners'],
  ['Director', 'directors'],
  ['Manager', 'managers'],
  ['Team', 'teamMembers'],
];

const EngagementRoster = ({ engagement, className = '' }) => (
  <dl className={`grid grid-cols-[max-content_1fr] gap-x-3 gap-y-0.5 text-xs ${className}`}>
    {ROLES.map(([label, key]) => (
      <React.Fragment key={key}>
        <dt className="text-slate-500">{label}</dt>
        <dd className="text-slate-800 break-words">
          <StaffNames list={(engagement && engagement[key]) || []} />
        </dd>
      </React.Fragment>
    ))}
  </dl>
);

export default EngagementRoster;
